export default __webpack_public_path__ + "static/media/musicAnimate.91048862.svg";